export default {
    API_URL: 'https://api.rendamonitorada.com.br/api', 
    OAPI_URL: 'https://api.rendamonitorada.com.br/oapi',
    //API_URL: 'http://localhost:3000/api', 
    //OAPI_URL: 'http://localhost:3000/oapi',
}